export enum CurrencyModes{
    None = "",
    Both = "B",
    Foreign = "F",
    Local = "D",
}